<template>
  <v-card :color="'rgb(250, 250, 250)'" class="elevation-0">
    <v-dialog v-model="dialogFormularioUsuario" :max-width="900" persistent>
      <v-card :color="'rgb(250, 250, 250)'" class="elevation-0">
        <v-toolbar dense :color="colorBarraFormulario" dark flat>
          <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
            <span v-bind:style="{ color: 'white' }">Usuario</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-chip class="mr-2 px-10" label :color="colorAccent1" text-color="white" link
            :disabled="loadingUsuario" @click="_crearUsuarioOrigen">
            <span v-if="loadingUsuario" v-bind:style="{ color: 'white' }">Guardando...</span>
            <span v-else v-bind:style="{ color: 'white' }">Crear Usuario</span>
          </v-chip>
          <v-icon size="30" :color="'white'" @click="dialogFormularioUsuario = false">mdi-close-circle</v-icon>
        </v-toolbar>
        <v-card-text>
          <v-alert v-if="usuarioError" dense outlined type="error" class="mt-4 mb-4">
            {{ usuarioError }}
          </v-alert>

          <v-row class="mt-6" dense>
            <v-col cols="12" md="6">
              <v-text-field v-model="modelUsuario.nombre" outlined label="Nombre" dense :dark="dark"
                autocomplete="off"></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field v-model="modelUsuario.email" outlined label="Email" dense :dark="dark"
                autocomplete="off"></v-text-field>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12" md="6">
              <v-text-field v-model="modelUsuario.password" outlined label="Contraseña" dense :dark="dark"
                autocomplete="new-password" type="password"></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field v-model="modelUsuario.password_confirmation" outlined label="Repetir contraseña" dense
                :dark="dark" autocomplete="new-password" type="password"></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-toolbar dense :color="colorBarraFormulario" dark flat>
      <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
        <span v-bind:style="{ color: 'white' }">Agencia</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-chip class="mr-2 px-10" label :color="colorAccent1" text-color="white" link @click="_guardarOrigen(false)">
        <span v-if="loading" v-bind:style="{ color: 'white' }">Guardando...</span>
        <span v-else v-bind:style="{ color: 'white' }">Guardar</span>
      </v-chip>
      <v-chip class="mr-2 px-10" label :color="colorAccent1" text-color="white" link @click="_guardarOrigen(true)">
        <span v-if="loading" v-bind:style="{ color: 'white' }">Guardando...</span>
        <span v-else v-bind:style="{ color: 'white' }">Guardar y Cerrar</span>
      </v-chip>
      <v-icon size="30" :color="'white'" @click="_cerrarVentana">mdi-close-circle</v-icon>
    </v-toolbar>
    <v-card-text>
      <v-row class="mt-6" dense>
        <v-col cols="12" class="ml-0">
          <v-row dense class="mx-4">
            <v-col cols="12" md="6" class="pa-0 pr-md-6">
              <div class="subtitle-2 font-weight-bold mb-4">
                DATOS AGENCIA
              </div>

               <v-row dense>
                <v-col cols="12" md="8">
                  <v-select v-model="modelOrigen.grupo_id" :items="grupos" item-text="nombre" item-value="id"
                    outlined label="Grupo" dense :dark="dark"
                    :loading="loadingGrupoOrigen" :disabled="loadingGrupoOrigen"
                    @change="_actualizarGrupoOrigen"></v-select>
                </v-col>
                <v-col class="d-flex align-center ml-8 dense">
                  <v-switch v-model="modelOrigen.is_active" inset label="Activa" :dark="dark"
                    :disabled="!modelOrigen.id || loadingEstadoOrigen" :loading="loadingEstadoOrigen"
                    @change="_actualizarEstadoOrigen"></v-switch>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="12">
                  <v-text-field v-model="modelOrigen.nombre" outlined label="Nombre" dense :dark="dark"
                    autocomplete="off"></v-text-field>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="12">
                  <v-textarea outlined v-model="modelOrigen.descripcion" :dark="dark" label="Descripcion"></v-textarea>
                </v-col>
              </v-row>

              <v-row v-if="grupoError" dense>
                <v-col cols="12">
                  <v-alert dense outlined type="warning" class="mb-0">
                    {{ grupoError }}
                  </v-alert>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="12">
                  <v-text-field v-model="modelOrigen.responsable" outlined label="Responsable" dense :dark="dark"
                    autocomplete="off"></v-text-field>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="12">
                  <v-text-field v-model="modelOrigen.telefono" outlined label="Teléfono" dense :dark="dark"
                    autocomplete="off"></v-text-field>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="12">
                  <v-text-field v-model="modelOrigen.email" outlined label="Email" dense :dark="dark"
                    autocomplete="off"></v-text-field>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" md="6" class="pa-0 pl-md-6 origen-formulario__fiscal-col">
              <div class="subtitle-2 font-weight-bold mb-4">
                DATOS FISCALES
              </div>

              <v-row dense>
                <v-col cols="12">
                  <v-text-field v-model="modelOrigen.nombre_fiscal" outlined label="Nombre fiscal" dense :dark="dark"
                    autocomplete="off"></v-text-field>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="12">
                  <v-text-field v-model="modelOrigen.cif" outlined label="Cif" dense :dark="dark"
                    autocomplete="off"></v-text-field>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="12">
                  <v-text-field v-model="modelOrigen.direccion_fiscal" outlined label="Dirección" dense :dark="dark"
                    autocomplete="off"></v-text-field>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="12">
                  <v-text-field v-model="modelOrigen.cod_postal_fiscal" outlined label="Codigo Postal" dense :dark="dark"
                    autocomplete="off"></v-text-field>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="12">
                  <v-text-field v-model="modelOrigen.poblacion_fiscal" outlined label="Población" dense :dark="dark"
                    autocomplete="off"></v-text-field>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="12">
                  <v-text-field v-model="modelOrigen.provincia_fiscal" outlined label="Provincia" dense :dark="dark"
                    autocomplete="off"></v-text-field>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="12">
                  <v-text-field v-model="modelOrigen.pais_fiscal" outlined label="País" dense :dark="dark"
                    autocomplete="off"></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <!-- Usuarios -->
          <v-card class="mx-4 my-2 elevation-1" color="rgb(250, 250, 250)">
            <v-toolbar dense :color="colorBarraFormulario" dark flat>
              <v-toolbar-title>
                <span class="subtitle-2">Usuarios</span>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-chip class="mr-2 px-6" label :color="colorAccent1" text-color="white" link
                :disabled="!modelOrigen.id" @click="_abrirDialogUsuario">
                <span v-bind:style="{ color: 'white' }">Agregar Usuario</span>
              </v-chip>
              <v-chip label class="mr-1 px-1" link color="transparent" @click="usuariosCardExpandida = !usuariosCardExpandida">
                <v-icon color="white">
                  {{ usuariosCardExpandida ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                </v-icon>
              </v-chip>
            </v-toolbar>
            <v-expand-transition>
              <div v-show="usuariosCardExpandida" class="pa-4">
                <v-alert v-if="!modelOrigen.id" dense outlined type="info" class="mb-4">
                  Guarda primero la agencia para poder agregar usuarios.
                </v-alert>
                <v-alert v-if="usuarioError" dense outlined type="error" class="mb-4">
                  {{ usuarioError }}
                </v-alert>
                <v-alert v-if="usuarioSuccess" dense outlined type="success" class="mb-4">
                  {{ usuarioSuccess }}
                </v-alert>

                <v-data-table v-if="usuariosOrigen.length" locale="es" dense hide-default-footer
                  :headers="headersUsuarios" :items="usuariosOrigen" class="elevation-1 alternating-rows bordered-table mt-2">
                  <template v-slot:[`item.nombre`]="{ item }">
                    {{ item.nombre || item.username || "Sin nombre" }}
                  </template>

                  <template v-slot:[`item.email`]="{ item }">
                    {{ item.email || "-" }}
                  </template>

                  <template v-slot:[`item.telefono`]="{ item }">
                    {{ item.telefono || "-" }}
                  </template>

                  <template v-slot:[`item.username`]="{ item }">
                    {{ item.username || "-" }}
                  </template>

                  <template v-slot:[`item.estado`]="{ item }">
                    <v-chip small label link :disabled="_isLoadingEstadoUsuario(item)"
                      :color="_getUsuarioEstadoColor(item)" text-color="white" @click="_actualizarEstadoUsuario(item)">
                      <v-progress-circular v-if="_isLoadingEstadoUsuario(item)" indeterminate size="14" width="2"
                        color="white" class="mr-1"></v-progress-circular>
                      {{ _getUsuarioEstadoText(item) }}
                    </v-chip>
                  </template>

                  <template v-slot:[`item.actions`]="{ item }">
                    <v-menu bottom left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on" :disabled="_isLoadingCredencialesUsuario(item)">
                          <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                      </template>

                      <v-list>
                        <v-list-item :disabled="!_isUsuarioActive(item) || _isLoadingCredencialesUsuario(item)"
                          @click="_enviarCredencialesUsuario(item)">
                          <v-list-item-title>Enviar Credenciales</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </template>
                </v-data-table>
                <v-alert v-else-if="modelOrigen.id" dense outlined type="info" class="mt-4 mb-0">
                  Esta agencia no tiene usuarios asociados.
                </v-alert>
              </div>
            </v-expand-transition>
          </v-card>

          <!-- Caminos Permitidos -->
          <v-card class="mx-4 my-2 elevation-1" color="rgb(250, 250, 250)">
            <v-toolbar dense :color="colorBarraFormulario" dark flat>
              <v-toolbar-title>
                <span class="subtitle-2">Caminos permitidos</span>
              </v-toolbar-title>
              <v-chip small label class="ml-3" color="blue-grey darken-3" text-color="white">
                {{ caminosSeleccionadosCount }} / {{ totalCaminos }}
              </v-chip>
              <v-spacer></v-spacer>
              <v-chip label class="mr-2" :color="colorAccent1" text-color="white" link
                @click="_seleccionarTodosCaminos">
                Marcar todos
              </v-chip>
              <v-chip label class="mr-2" :color="colorAccent3" text-color="white" link @click="_deseleccionarTodosCaminos">
                Desmarcar todos
              </v-chip>
              <v-chip label class="mr-1 px-1" link color="transparent" @click="caminosCardExpandida = !caminosCardExpandida">
                <v-icon color="white">
                  {{ caminosCardExpandida ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                </v-icon>
              </v-chip>
            </v-toolbar>
            <v-expand-transition>
              <div v-show="caminosCardExpandida" class="pa-4">
                <v-checkbox v-for="camino in caminosEstandar" :key="camino.id" v-model="selectedCaminos"
                  :value="camino.id" dense hide-details :dark="dark">
                  <template v-slot:label>
                    <span>{{ camino.titulo }}</span>
                  </template>
                </v-checkbox>
              </div>
            </v-expand-transition>
          </v-card>

        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";


export default {
  name: "OrigenFormulario",

  data: () => ({
    loading: false,
    headersUsuarios: [
      { text: "Nombre", value: "nombre", sortable: false },
      { text: "Email", value: "email", sortable: false },
      { text: "Teléfono", value: "telefono", sortable: false },
      { text: "Usuario", value: "username", sortable: false },
      { text: "Estado", value: "estado", sortable: false, align: "center" },
      { text: "", value: "actions", sortable: false, align: "end", width: "48px" },
    ],
    selectedCaminos: [],
    caminosInicializados: false,
    caminosCardExpandida: true,
    usuariosCardExpandida: true,
    dialogFormularioUsuario: false,
    loadingUsuario: false,
    loadingEstadoOrigen: false,
    loadingGrupoOrigen: false,
    loadingEstadoUsuarios: {},
    loadingCredencialesUsuarios: {},
    usuarioError: null,
    usuarioSuccess: null,
    ultimoGrupoSeleccionadoId: null,
    modelUsuario: {
      nombre: null,
      email: null,
      password: null,
      password_confirmation: null,
    },
    grupoError: null,
  }),

  props: {
    modelOrigen: {
      type: Object,
      required: true,
    },

    accion: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapState([
      "drawer",
      "dark",
      "colorAccent1",
      "colorAccent2",
      "colorAccent3",
      "colorBarraFormulario",
      "colorFondoDialog",
      "provincias",

    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),
    ...mapState("grupos", ["grupos"]),
    ...mapState("caminos", ["caminos"]),
    ...mapState("origenes", ["origenes"]),

    totalCaminos() {
      return this.caminosEstandar.length;
    },

    caminosSeleccionadosCount() {
      return this.selectedCaminos.filter((id) =>
        this.caminosEstandar.some((camino) => String(camino.id) === String(id))
      ).length;
    },

    caminosEstandar() {
      return (this.caminos || []).filter((camino) => this._esCaminoEstandar(camino));
    },

    usuariosOrigen() {
      return Array.isArray(this.modelOrigen && this.modelOrigen.users) ? this.modelOrigen.users : [];
    },

  },

  watch: {
    modelOrigen: {
      handler() {
        console.log("modelOrigen changed...", this.modelOrigen);
        this.caminosInicializados = false;
        this._initSelectedCaminos();
        this._sincronizarGrupoSeleccionado();
        this.ultimoGrupoSeleccionadoId = this._extraerGrupoId(this._obtenerGrupoActual());
      },
      immediate: true,
    },
    grupos() {
      this._sincronizarGrupoSeleccionado();
    },
    caminos() {
      this.caminosInicializados = false;
      this._initSelectedCaminos();
    },
  },

  mounted() {
    this._cargarGrupos();
    this._cargarCaminos();
  },

  methods: {
    ...mapActions("origenes", ["getOrigenes", "crearOrigen", "updateOrigen", "crearUsuarioOrigen", "updateOrigenIsActive", "updateOrigenGrupo", "updateUserIsActive", "enviarCredencialesUsuario"]),
    ...mapActions("grupos", ["getGrupos"]),
    ...mapActions("caminos", ["getCaminos"]),

    _cerrarVentana() {
      this.$emit("cerrarFormularioOrigen");
    },

    async _cargarCaminos() {
      await this.getCaminos([this.access_token, false]);
      this._initSelectedCaminos();
    },

    async _cargarGrupos() {
      await this.getGrupos([this.access_token, false]);
    },

    _obtenerGrupoActual() {
      if (!this.modelOrigen) {
        return null;
      }

      if (this.modelOrigen.grupo_id != null && this.modelOrigen.grupo_id !== "") {
        return this.modelOrigen.grupo_id;
      }

      if (this.modelOrigen.grupo && this.modelOrigen.grupo.id != null) {
        return this.modelOrigen.grupo.id;
      }

      return this.modelOrigen.grupo || null;
    },

    _extraerGrupoId(grupo) {
      if (grupo == null || grupo === "") {
        return null;
      }

      if (typeof grupo === "object") {
        return grupo.id != null ? grupo.id : null;
      }

      return grupo;
    },

    _buscarGrupoPorId(grupoId) {
      return (this.grupos || []).find(
        (item) => item.id === grupoId || String(item.id) === String(grupoId)
      ) || null;
    },

    _sincronizarGrupoSeleccionado() {
      if (!this.modelOrigen) {
        return;
      }

      const grupoId = this._extraerGrupoId(this._obtenerGrupoActual());
      if (grupoId == null) {
        return;
      }

      const grupoEncontrado = this._buscarGrupoPorId(grupoId);
      if (grupoEncontrado) {
        this.modelOrigen.grupo_id = grupoEncontrado.id;
        this.modelOrigen.grupo = grupoEncontrado;
      }
    },

    _esCaminoEstandar(camino) {
      return Number(camino?.categoria_id || 0) <= 10;
    },

    _normalizarGrupoId() {
      const grupo = this._obtenerGrupoActual();
      this.grupoError = null;

      if (grupo == null || grupo === "") {
        this.grupoError = "Selecciona un grupo.";
        return null;
      }

      if (typeof grupo === "object") {
        if (grupo.id != null) {
          return grupo.id;
        }

        this.grupoError = "Selecciona un grupo existente.";
        return null;
      }

      if (typeof grupo === "string") {
        const grupoEncontrado = (this.grupos || []).find(
          (item) => item.nombre && item.nombre.toLowerCase() === grupo.toLowerCase()
        );

        if (grupoEncontrado) {
          return grupoEncontrado.id;
        }

        this.grupoError = "Selecciona un grupo existente.";
        return null;
      }

      return grupo;
    },

    async _actualizarGrupoOrigen(value) {
      const grupoId = this._normalizarGrupoId();

      if (grupoId == null) {
        if (this.modelOrigen) {
          this.modelOrigen.grupo_id = this.ultimoGrupoSeleccionadoId;
          this.modelOrigen.grupo = this._buscarGrupoPorId(this.ultimoGrupoSeleccionadoId);
        }
        return;
      }

      const grupoSeleccionado = this._buscarGrupoPorId(grupoId) || null;

      if (this.modelOrigen) {
        this.modelOrigen.grupo_id = grupoId;
        this.modelOrigen.grupo = grupoSeleccionado;
      }

      if (!this.modelOrigen || !this.modelOrigen.id || this.loadingGrupoOrigen) {
        this.ultimoGrupoSeleccionadoId = grupoId;
        return;
      }

      this.loadingGrupoOrigen = true;
      this.grupoError = null;

      const grupoAnteriorId = this.ultimoGrupoSeleccionadoId;
      const res = await this.updateOrigenGrupo([
        this.access_token,
        this.modelOrigen.id,
        grupoId,
      ]);

      if (res && res.status === 200) {
        const origenActualizado = res.data && (res.data.origen || res.data.data || res.data);
        if (origenActualizado && origenActualizado.id) {
          Object.assign(this.modelOrigen, JSON.parse(JSON.stringify(origenActualizado)));
        }
        this.ultimoGrupoSeleccionadoId = grupoId;
        await this.getOrigenes([this.access_token, false]);
        await this.getGrupos([this.access_token, false]);
        this._sincronizarOrigenDesdeStore();
      } else {
        this.modelOrigen.grupo_id = grupoAnteriorId;
        this.modelOrigen.grupo = this._buscarGrupoPorId(grupoAnteriorId);
        this.grupoError = res && res.data && res.data.message
          ? res.data.message
          : "No se pudo actualizar el grupo de la agencia.";
      }

      this.loadingGrupoOrigen = false;
    },

    _normalizarIsActive() {
      const value = this.modelOrigen ? this.modelOrigen.is_active : false;
      this.modelOrigen.is_active = value === true || value === 1 || value === "1" || value === "true";
    },

    async _actualizarEstadoOrigen(value) {
      if (!this.modelOrigen || !this.modelOrigen.id || this.loadingEstadoOrigen) {
        return;
      }

      const estadoAnterior = value === true ? false : value === false ? true : !value;
      const nuevoEstado = value === true || value === 1 || value === "1" || value === "true";

      this.loadingEstadoOrigen = true;
      this.usuarioError = null;

      const res = await this.updateOrigenIsActive([
        this.access_token,
        this.modelOrigen.id,
        nuevoEstado,
      ]);

      if (res && res.status === 200 && res.data && res.data.origen) {
        Object.assign(this.modelOrigen, JSON.parse(JSON.stringify(res.data.origen)));
        this._normalizarIsActive();
      } else {
        this.modelOrigen.is_active = estadoAnterior;
        this.usuarioError = res && res.data && res.data.message
          ? res.data.message
          : "No se pudo actualizar el estado de la agencia.";
      }

      this.loadingEstadoOrigen = false;
    },

    _initSelectedCaminos() {
      console.log("Inicializando caminos permitidos...", this.caminos);
      if (this.caminosInicializados || !this.caminos) {
        return;
      }
      if (!this.caminos.length) {
        this.caminosInicializados = true;
        return;
      }

      const raw = this.modelOrigen ? this.modelOrigen.caminos_permitidos : null;
      if (!raw) {
        this.selectedCaminos = [];
        this.caminosInicializados = true;
        return;
      }

      try {
        const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
        const ids = Array.isArray(parsed)
          ? parsed.map((item) => (item && item.id != null ? item.id : item))
          : parsed.caminos_id || [];

        if (Array.isArray(ids)) {
          this.selectedCaminos = ids
            .map((id) => Number(id))
            .filter((id) => !Number.isNaN(id))
            .filter((id) =>
              this.caminosEstandar.some((camino) => String(camino.id) === String(id))
            );
        } else {
          this.selectedCaminos = [];
        }
      } catch (e) {
        this.selectedCaminos = [];
      }
      this.caminosInicializados = true;
    },

    _prepararCaminosPermitidosParaGuardar() {
      const seleccionados = this.selectedCaminos || [];
      const caminosIds = seleccionados
        .map((id) => Number(id))
        .filter((id) => !Number.isNaN(id))
        .filter((id) =>
          this.caminosEstandar.some((camino) => String(camino.id) === String(id))
        );

      this.modelOrigen.caminos_permitidos = JSON.stringify({
        caminos_id: caminosIds,
      });
    },

    _seleccionarTodosCaminos() {
      if (this.caminosEstandar.length) {
        this.selectedCaminos = this.caminosEstandar.map((c) => c.id);
      }
    },

    _deseleccionarTodosCaminos() {
      this.selectedCaminos = [];
    },

    _resetUsuarioForm() {
      this.modelUsuario = {
        nombre: null,
        email: null,
        password: null,
        password_confirmation: null,
      };
    },

    _abrirDialogUsuario() {
      this.usuarioError = null;
      this.usuarioSuccess = null;
      this._resetUsuarioForm();
      this.dialogFormularioUsuario = true;
    },

    _validarUsuario() {
      if (!this.modelOrigen.id) {
        return "Guarda primero la agencia para poder agregar usuarios.";
      }
      if (!this.modelUsuario.nombre || !this.modelUsuario.email || !this.modelUsuario.password || !this.modelUsuario.password_confirmation) {
        return "Completa nombre, email y las dos contraseñas.";
      }
      if (this.modelUsuario.password !== this.modelUsuario.password_confirmation) {
        return "Las contraseñas no coinciden.";
      }
      return null;
    },

    _isUsuarioActive(usuario) {
      const value = usuario ? usuario.is_active : false;
      return value === true || value === 1 || value === "1" || value === "true";
    },

    _getUsuarioEstadoColor(usuario) {
      return this._isUsuarioActive(usuario) ? "green lighten-1" : "red lighten-2";
    },

    _getUsuarioEstadoText(usuario) {
      return this._isUsuarioActive(usuario) ? "ACTIVO" : "INACTIVO";
    },

    _isLoadingEstadoUsuario(usuario) {
      if (!usuario || usuario.id == null) {
        return false;
      }

      return this.loadingEstadoUsuarios[String(usuario.id)] === true;
    },

    _isLoadingCredencialesUsuario(usuario) {
      if (!usuario || usuario.id == null) {
        return false;
      }

      return this.loadingCredencialesUsuarios[String(usuario.id)] === true;
    },

    async _actualizarEstadoUsuario(usuario) {
      if (!usuario || usuario.id == null || this._isLoadingEstadoUsuario(usuario)) {
        return;
      }

      const userId = String(usuario.id);
      const estadoAnterior = this._isUsuarioActive(usuario);
      const nuevoEstado = !estadoAnterior;

      this.$set(this.loadingEstadoUsuarios, userId, true);
      this.usuarioError = null;
      this.usuarioSuccess = null;

      const res = await this.updateUserIsActive([
        this.access_token,
        usuario.id,
        nuevoEstado,
      ]);

      if (res && res.status === 200) {
        const userActualizado = res.data && (res.data.user || res.data.data || res.data.usuario)
          ? { ...usuario, ...(res.data.user || res.data.data || res.data.usuario) }
          : { ...usuario, is_active: nuevoEstado };

        const usuariosActualizados = this.usuariosOrigen.map((item) =>
          String(item.id) === userId ? userActualizado : item
        );

        this.$set(this.modelOrigen, "users", usuariosActualizados);
        this.$store.commit("origenes/actUserInOrigenes", { user_id: usuario.id, user: userActualizado });
        this.$store.commit("grupos/actUserInOrigenesFromGrupos", { user_id: usuario.id, user: userActualizado });
      } else {
        this.usuarioError = res && res.data && res.data.message
          ? res.data.message
          : "No se pudo actualizar el estado del usuario.";
      }

      this.$set(this.loadingEstadoUsuarios, userId, false);
    },

    async _enviarCredencialesUsuario(usuario) {
      if (!usuario || usuario.id == null || !this.modelOrigen || !this.modelOrigen.id || this._isLoadingCredencialesUsuario(usuario)) {
        return;
      }

      const userId = String(usuario.id);
      this.usuarioError = null;
      this.usuarioSuccess = null;
      this.$set(this.loadingCredencialesUsuarios, userId, true);

      const res = await this.enviarCredencialesUsuario([
        this.access_token,
        usuario.id,
        this.modelOrigen.id,
      ]);

      if (res && res.status === 200) {
        if (res.data && res.data.origen) {
          Object.assign(this.modelOrigen, JSON.parse(JSON.stringify(res.data.origen)));
          this._normalizarIsActive();
        }
        this.usuarioSuccess = res && res.data && res.data.message
          ? res.data.message
          : "Credenciales enviadas correctamente.";
      } else {
        this.usuarioError = res && res.data && res.data.message
          ? res.data.message
          : "No se pudieron enviar las credenciales.";
      }

      this.$set(this.loadingCredencialesUsuarios, userId, false);
    },

    _sincronizarOrigenDesdeStore() {
      if (!this.modelOrigen || !this.modelOrigen.id) {
        return;
      }

      const origenActualizado = (this.origenes || []).find(
        (item) => String(item.id) === String(this.modelOrigen.id)
      );

      if (origenActualizado) {
        Object.assign(this.modelOrigen, JSON.parse(JSON.stringify(origenActualizado)));
      }
    },

    async _crearUsuarioOrigen() {
      this.usuarioError = null;
      this.usuarioSuccess = null;

      const error = this._validarUsuario();
      if (error) {
        this.usuarioError = error;
        return;
      }

      this.loadingUsuario = true;
      const res = await this.crearUsuarioOrigen([
        this.access_token,
        {
          origen_id: this.modelOrigen.id,
          nombre: this.modelUsuario.nombre,
          email: this.modelUsuario.email,
          password: this.modelUsuario.password,
          password_confirmation: this.modelUsuario.password_confirmation,
        },
      ]);
      this.loadingUsuario = false;

      if (res && (res.status === 200 || res.status === 201)) {
        this.usuarioSuccess = "Usuario creado correctamente.";
        this.dialogFormularioUsuario = false;
        this._resetUsuarioForm();
        await this.getOrigenes([this.access_token, false]);
        await this.getGrupos([this.access_token, false]);
        this._sincronizarOrigenDesdeStore();
      } else {
        this.usuarioError = res && res.data && res.data.message ? res.data.message : "No se pudo crear el usuario.";
      }
    },

    async _guardarOrigen(cerrar) {
      this.loading = true;
      const grupoId = this._normalizarGrupoId();
      if (grupoId == null) {
        this.loading = false;
        return;
      }

      this.modelOrigen.grupo_id = grupoId;
      this._normalizarIsActive();
      this._prepararCaminosPermitidosParaGuardar();
      if (this.accion == "crear" && !this.modelOrigen.id) {
        var res = await this.crearOrigen([
          this.access_token,
          this.modelOrigen,
        ]);
        if (res && res.data) {
          Object.assign(this.modelOrigen, res.data.data || res.data);
        }
        await this.getOrigenes([this.access_token, false]);
        await this.getGrupos([this.access_token, false]);
        this._sincronizarOrigenDesdeStore();
      } else if (this.accion == "editar" || this.modelOrigen.id) {
        var res = await this.updateOrigen([
          this.access_token,
          this.modelOrigen,
        ]);
        await this.getOrigenes([this.access_token, false]);
        await this.getGrupos([this.access_token, false]);
        this._sincronizarOrigenDesdeStore();
      }

      if (cerrar) {
        this._cerrarVentana();
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.l-map {
  height: 100%;
  width: 100%;
}

.origen-formulario__fiscal-col {
  border-left: 1px solid rgba(0, 0, 0, 0.12);
}

@media (max-width: 959px) {
  .origen-formulario__fiscal-col {
    border-left: 0;
    border-top: 1px solid rgba(0, 0, 0, 0.12);
    margin-top: 8px;
    padding-top: 20px !important;
  }
}
</style>
